<template>
  <section id="mission" class="mission container main">
        <div class="wrapper two-col">
          <h2 class="left" data-aos="fade-right">
              <SvgTitle class="hideSp"/>
              <SvgTitleSp class="hidePc" />
              <caption>MISSION LEADS IDEA</caption></h2>
          <div class="text-box right" data-aos="fade-up">
            <h3>私たちは、<br>
            「人を動かすクリエイティブ」を<br class="hidePc">約束します。</h3>
            <ol>
                <li>
                    <span><img :src="m01" alt="Mission 01"></span>
                    <h4>ブランド(企業)が持つ価値を軸とした<br>
                    コミニケーションの設計。</h4>
                </li>
                <li>
                    <span><img :src="m02" alt="Mission 02"></span>
                    <h4>社会問題を洞察し解決の糸口を発見、<br>
                    より良い社会づくりへの貢献。</h4>
                </li>
                <li>
                    <span><img :src="m03" alt="Mission 03"></span>
                    <h4>地域や伝統文化の「隠れた事実」に光をあて、<br class="hideSp">
                        新しい価値の創造。</h4>
                </li>
            </ol>
          </div>
        </div>    
    </section>
</template>

<script>
import SvgTitle from '@/assets/icon/h2/mission.svg?inline'
import SvgTitleSp from '@/assets/icon/h2/mission_sp.svg?inline'
import m01 from '@/assets/icon/h2/m01.svg'
import m02 from '@/assets/icon/h2/m02.svg'
import m03 from '@/assets/icon/h2/m03.svg'

export default {
  name: 'section-mission',
  components: {
      SvgTitle,
      SvgTitleSp,
      m01,
      m02,
      m03,
  },
  created(){
      this.m01 = m01
      this.m02 = m02
      this.m03 = m03
  }
}
</script>

<style lang="scss">

#mission{
    .wrapper{
        h3{
            margin-top: -0.54em;
            @media #{$maxL}{
                margin-top: 0;
            }
        }
        .left{
            width: 24.46%;
            padding-right: calc(9.84vw - 57px);
            @media #{$maxL}{
                width: 100%;
                height: 5.4666vw;
                padding: 0;
                margin: 0;
                margin-bottom: 36px;
                max-height: 43px;
                    svg{
                        height: 100%;
                        width: auto;
                    }
            }
            
        }
        .right{
            width: 70%;
            @media #{$maxL}{
                width: 100%;
            }
            ol{
                li{
                    display: flex;
                    justify-content: flex-start;
                    align-items: stretch;
                    flex-flow: row nowrap;
                    height: 3.32em;
                    margin-bottom: 40px;
                    &:last-child{
                        margin-bottom: 0;
                    }
                    span{
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        width: 82px;
                        overflow: hidden;
                        margin-right: 30px;
                        @media #{$maxL}{
                            width: 10.13333vw;
                            height: calc(100% - 12px);
                            padding: 6px 0;
                            justify-content: center;
                            overflow: visible;
                            margin-right: 16px;
                        }
                        img{
                            height: 100%;
                            width: 100%;
                            display: block;
                        }
                    }
                    h4{
                        display: block;
                        width: 100%;
                    }
                }
            }
        }

    }
}
</style>
